<template>
  <header class="download-main-logo download-main-top">
    <img src="../assets/images/xiaolu-logo.png" class="logo-img" alt="" />
  </header>
</template>

<script>
/* eslint-disable */
export default { name: "HeadBar" };
</script>

<style lang="less">
#download-wrapper .download-main .download-main-logo {
  padding: 80px 0;
  overflow: hidden;
}

#download-wrapper .download-main .download-main-logo .logo-img {
  // width: 195px;
  height: 39px;
  padding-right: 30px;
  margin-right: 30px;
  /*border-right: 1px solid #cef5e0;*/
  float: left;
}

#download-wrapper .download-main .download-main-logo .logo-type {
  float: left;
  line-height: 57px;
  font-weight: lighter;
  font-size: 30px;
  color: #333;
}
</style>
